import React, {useState, useEffect} from 'react';
import { useLocalStorage, useDebounce} from 'react-use';
import {
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import FileUpload from 'components/FileUpload/FileUpload.js';
import useNotif from 'hooks/use-notify-hook';
import AnswerRepository from 'repository/Answer.js';
import moment from 'moment';

export default function Table({answer, schedule, isReadonly}) {

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [attachments, setAttachments] = useState(answer?.answerAttachments ?? []);
  // const [evaluation, setEvaluation] = useState(answer?.EVALUATE_DESC ?? ``);
  const [explanation , setExplanation] = useState(answer.ADD_EXPLAN ?? '');
  const repository = new AnswerRepository(auth.token);

  let filePromises = [];

  const handleUpload = async (file) => {

    try {

      filePromises.push(repository.upload(answer.ANSWER_ID, file));

      const promises = await Promise.all(filePromises);
      // setAttachments([...attachments, ...promises.map(item => item.data)]);
      promises.map(item => attachments.push(item.data));
      dispatchNotif({
        place: `br`,
        message: `Upload Success...`,
        type: `success`,
      });

      filePromises = [];

      dispatchNotif({
        place: `br`,
        message: `Upload Success...`,
        type: `success`,
      });

    } catch(ex) {

      dispatchNotif({
        place: `br`,
        message: `Upload Failed ${ex.toString()}`,
        type: `danger`,
      });
    }
  }

  const handleDeleteAttachment = async(attachmentId) => {

    try{

      const response = await repository.deleteAttachment(attachmentId);

      dispatchNotif({
        place: `br`,
        message: `Delete Success...`,
        type: `success`,
      });

      var data =  attachments.filter(attachment => attachment.ATTACHMENT_ID != attachmentId);

      setAttachments(data);

    }catch(ex){

      dispatchNotif({
        place: `br`,
        message: `Failed ${ex.toString()}`,
        type: `danger`,
      });

    }
  }

  const [, cancelInput] = useDebounce(async () => {

    try {

      const data = {
        ANSWER_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
        ANSWER_BY: auth.employee.EMP_ID,
        ADD_EXPLAN: explanation,
      };

      const response = await repository.answer(answer.ANSWER_ID, data);

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    }catch(ex){
      dispatchNotif({
        place: `br`,
        message: `Failed: ${ex.toString()}`,
        type: `danger`,
      });
    }


  }, 2000, [explanation]);

  useEffect(() => {

    cancelInput();

  }, []);

  return (
    <Row>
      {notif}
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title as="h5">{answer.question.QUESTION_CODE}. {answer?.question?.QUESTION_LABEL}</Card.Title>
            <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer?.question?.QUESTION_DESC}} />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="8">
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Answer</Form.Label>
                  {schedule?.FORM_FILE
                    ? <p>The answer calculated is being calculated</p>
                    : <p className="text-danger">You need to upload form spreadsheet from template to be able to answer this question.</p>}
                </Form.Group>
                {/* <Form.Group>
                  <Form.Label>Additional Explanation:</Form.Label>
                  <Form.Control
                    value={explanation}
                    onChange={({ target: {value }}) => setExplanation(value)}
                    as="textarea"
                    rows={3}
                    disabled={isReadonly}
                    isInvalid={explanation?.length > 4000}
                  />
                </Form.Group> */}
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Additional Explanation</Form.Label>
                  {isReadonly
                    ? <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: explanation}} />
                    : (
                      <>
                        <Form.Control
                          value={explanation}
                          onChange={({ target: { value } }) => setExplanation(value)}
                          as="textarea"
                          rows={3}
                          disabled={isReadonly}
                          isInvalid={explanation?.length > 4000}
                        />
                        <Form.Text id="passwordHelpBlock" muted>
                          Total characters: {explanation?.length ?? 0} / 4000
                        </Form.Text>
                      </>
                    )
                  }
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Evaluation</Form.Label>
                  <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.EVALUATE_DESC}} />
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group>
                  <Form.Label>Attachment(s)</Form.Label>
                  {attachments && attachments.length > 0
                    ? (
                      <span className="form-control"
                        style={{
                          maxHeight: `200px`,
                          height: `200px`,
                          overflowY: `scroll`,
                          marginBottom: `10px`
                        }}
                      >
                        {attachments.map((attachment, key) => (
                          <div key={key} className="font-icon-detail">
                            <i className="nc-icon nc-attach-87"></i>{' '}
                            <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`} target="_blank" rel="noopener noreferrer">
                              {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                            </a>{' '}
                            {!isReadonly && (
                              <button
                                className="btn btn-danger nc-icon nc-simple-remove"
                                value={attachment.ATTACHMENT_ID}
                                onClick={() => handleDeleteAttachment(attachment.ATTACHMENT_ID)}>
                              </button>
                            )}
                          </div>
                        ))}
                      </span>
                    )
                    : <p>No file uploaded.</p>
                  }
                  {!isReadonly && (
                    <FileUpload
                      onFileSelectSuccess={(file) => handleUpload(file)}
                      onFileSelectError={({ error }) => alert(error)}
                      disabled={isReadonly}
                    >
                      Upload
                    </FileUpload>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
